export const MODALS_ID = {
  ASK_QUESTION_MODAL: "ASK_QUESTION_MODAL",
  BLOCKED_MODULE_MODAL: "BLOCKED_MODULE_MODAL",
  BLOCKED_LESSON_MODAL: "BLOCKED_LESSON_MODAL",
  DISCLAIMER_MODAL: "DISCLAIMER_MODAL",
};
